import { render } from "./MsTr.vue?vue&type=template&id=5d886c64&scoped=true"
import script from "./MsTr.vue?vue&type=script&lang=js"
export * from "./MsTr.vue?vue&type=script&lang=js"

import "./MsTr.vue?vue&type=style&index=0&id=5d886c64&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5d886c64"]])

export default __exports__